module.exports = __webpack_public_path__ + "static/media/noimage.001b5f37.jpg";